module.exports = "https://bin.bnbstatic.com/_next/static/images/DOCK_app-CN-3b975045e2c7121fdf68b02451ee55fa.jpg";